import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-8 pb-16 md:pt-12 md:pb-24 overflow-hidden bg-[#FDFBF7]" data-id="element-89">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-90">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-91">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="order-2 md:order-1" data-id="element-92">
            <div className="inline-flex items-center gap-2 bg-red-50 text-red-700 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-6" data-id="element-93">
              <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-94"></span>
              Últimas Unidades Disponibles
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-[1.1] mb-6" data-id="element-95">
              Reduce la barriga visible en 14 dias{' '}
              <span className="text-[#D4AF37]" data-id="element-96">sin dietas extremas</span>
            </h1>

            <p className="text-xl text-gray-600 mb-2 font-medium" data-id="element-97">
              Reduce inflamación Y quema grasa abdominal.
            </p>

            <p className="text-lg text-gray-500 mb-8 leading-relaxed" data-id="element-98">
              El primer parche de micro-activación con veneno de abeja diseñado
              para reactivar tu metabolismo, quemar grasa y reducir la hinchazón
              abdominal.
            </p>

            <div className="space-y-3 mb-8" data-id="element-99">
              {[{
              text: 'Hasta 8 kg en 21 días',
              time: 'Resultados reales'
            }, {
              text: 'Activa el metabolismo y quema grasa localizada',
              time: 'Efecto termogénico'
            }, {
              text: 'Reduce la hinchazón abdominal visible',
              time: 'En 7-14 días'
            }, {
              text: 'Apoya el drenaje linfático natural',
              time: 'Desde el día 1'
            }, {
              text: 'Sin pastillas difíciles de tragar',
              time: '100% tópico'
            }, {
              text: 'Fácil de usar: un parche al día',
              time: '8 horas de acción'
            }].map((benefit, i) => <div key={i} className="flex items-center gap-3" data-id="element-100">
                  <CheckCircle2 className="w-5 h-5 text-[#2D5016] flex-shrink-0" data-id="element-101" />
                  <div className="flex-1" data-id="element-102">
                    <span className="text-gray-700 font-medium" data-id="element-103">
                      {benefit.text}
                    </span>
                    <span className="ml-2 text-sm text-[#D4AF37] font-semibold" data-id="element-104">
                      • {benefit.time}
                    </span>
                  </div>
                </div>)}
            </div>

            <div className="flex flex-col gap-4" data-id="element-105">
              <Button size="xl" className="w-full group relative overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1" onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-106">
                <span className="relative z-10 flex items-center justify-center font-bold tracking-wide" data-id="element-107">
                  <Sparkles className="w-5 h-5 mr-2" data-id="element-108" />
                  SÍ, QUIERO REDUCIR MI BARRIGA
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-109" />
                </span>
              </Button>

              <div className="flex items-center justify-center gap-3 text-xs font-medium text-gray-500" data-id="element-110">
                <span className="flex items-center" data-id="element-111">
                  <CheckCircle2 className="w-3 h-3 text-green-600 mr-1" data-id="element-112" /> Envío
                  Gratis Hoy
                </span>
                <span className="w-1 h-1 bg-gray-300 rounded-full" data-id="element-113"></span>
                <span className="flex items-center" data-id="element-114">
                  <CheckCircle2 className="w-3 h-3 text-green-600 mr-1" data-id="element-115" />{' '}
                  Garantía 90 Días
                </span>
                <span className="w-1 h-1 bg-gray-300 rounded-full" data-id="element-116"></span>
                <span className="flex items-center" data-id="element-117">
                  <CheckCircle2 className="w-3 h-3 text-green-600 mr-1" data-id="element-118" /> Sin
                  Riesgo
                </span>
              </div>

              <div className="flex items-center justify-center gap-2 text-sm mt-2" data-id="element-119">
                <div className="flex -space-x-2" data-id="element-120">
                  {[32, 45, 67].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-gray-200 overflow-hidden" data-id="element-121">
                      <img src={`https://randomuser.me/api/portraits/women/${i}.jpg`} alt="User" data-id="element-122" />
                    </div>)}
                </div>
                <div className="text-left" data-id="element-123">
                  <p className="font-bold text-gray-900" data-id="element-124">+10.000 mujeres</p>
                  <p className="text-xs text-gray-500" data-id="element-125">
                    ya han transformado su cuerpo
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-1 md:order-2 relative" data-id="element-126">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-127">
              <img src="https://cdn.magicpatterns.com/uploads/dFPBUFJSxve5eZXCiqp6GP/imgi_10_1754196580-Copy_of_BeeBalm_–_lindrar_ledvark,_ischias,_artrit_och_halsporre_pa_bara_15_minuter_(4).png" alt="StingFit - Parche de veneno de abeja para drenaje linfático" className="w-full h-full object-contain bg-white" data-id="element-128" />
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-4 shadow-2xl max-w-[200px] border-2 border-[#D4AF37]" data-id="element-129">
              <div className="flex items-center gap-2 mb-1" data-id="element-130">
                <div className="w-3 h-3 bg-green-500 rounded-full" data-id="element-131"></div>
                <span className="text-xs font-bold text-green-700" data-id="element-132">
                  RESULTADO VERIFICADO
                </span>
              </div>
              <p className="text-sm font-bold text-gray-900" data-id="element-133">
                "Perdí 6 kg y 8 cm de cintura en 3 semanas."
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-134">- Carmen M., 42 años</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}